export default __webpack_public_path__ + "kalerab.png?20406091768288945f0566e4f25ff564";